// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"_2OsGT","checkbox":"_3Mtbs","primary":"ObKFU","rightCheckbox":"_1KQhV","input":"_3pQWB","withoutChildren":"_3LGPN"};